import React, { useContext } from 'react';
import clsx from 'clsx';
import { AppLayoutContext } from './context';
import styles from './styles.css.js';
import testutilStyles from '../test-utils/styles.css.js';
export default function Notifications() {
    var _a;
    var _b = useContext(AppLayoutContext), ariaLabels = _b.ariaLabels, hasNotificationsContent = _b.hasNotificationsContent, notifications = _b.notifications, notificationsElement = _b.notificationsElement, stickyNotifications = _b.stickyNotifications;
    if (!notifications) {
        return null;
    }
    return (React.createElement("div", { "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.notifications) !== null && _a !== void 0 ? _a : undefined, className: clsx(styles.notifications, testutilStyles.notifications, 'awsui-context-content-header'), "data-has-notifications-content": hasNotificationsContent ? true : false, "data-sticky": stickyNotifications ? 'true' : undefined, role: "region", ref: notificationsElement }, notifications));
}
